import type { ChakraProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import React from 'react';

export const HomeDivider = (props: ChakraProps) => {
  return <Box h="1px" bg="gradients.blue-border-vertical" {...props} />;
};
